import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../../utils/helpers/model.helper';
import { ITrackingObject, TrackingObjectNamesEnum } from '../../tracking.data';

export const TRACKING_HOME_SCREEN_SCHEMA = Object.freeze({});
const RECORD = generateSchema(TRACKING_HOME_SCREEN_SCHEMA);
const KEYS: any = generateKeys(TRACKING_HOME_SCREEN_SCHEMA);

export class HomeScreenTrackingObject
  extends Record(RECORD)
  implements ITrackingObject {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingObjectNamesEnum.home_screen;
  }

  get properties() {
    return this.toJS();
  }
}
